var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectable-entity-map"},[_c('EntityMap',{attrs:{"coordinates-list":_vm.coordinatesList,"selectedEntities":_vm.selectedEntities},on:{"selected":function (placeId) { return _vm.$emit('selected', placeId); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }